import type { LowerIsBetterLookup } from '../service/resolvePolarity'

import { useMetricCatalog } from '@/features/reports'

export interface AnomalyCatalogContext {
  metricLabel: (metricField: string) => string
  isLowerBetter: LowerIsBetterLookup
}

/** The catalog half of `AdaptAnomalyContext` (contract 28 §8): 08's `useMetricCatalog`
 *  answers first; a `null` from `isLowerBetter` defers to the static polarity fallback
 *  inside `resolvePolarity`. Callers spread this into the full adapt context and add the
 *  formatter half (`formatMetric`) themselves. */
export function useAnomalyCatalogContext(): AnomalyCatalogContext {
  const catalog = useMetricCatalog()
  return {
    metricLabel: (metricField) => catalog.metricLabel(metricField),
    isLowerBetter: (metricField) => catalog.isLowerBetter(metricField),
  }
}
